export const environment = {
  production: true,
  staging: false,
  proxy: false,
  apiRootUrl: 'https://wapi.xfeet-orthotics.com',
  apiHost: 'wapi.xfeet-orthotics.com',
  authHeaderName: 'xfeet-authorization',
  timeout: 120000,
  cdn: 'https://cdn.xfeet-orthotics.com/webapp/'
};
